import { ViewFilterName } from '../../../../filters/enum/types/ViewFilterName';

export const viewQuickFilterNames = [ViewFilterName._OfferDate, ViewFilterName.LocationListingLocation];
